var items = document.querySelectorAll('#float_left .list-menu .item');

function setActive(id) {
  items.forEach(function (el) { el.classList.remove('active'); });
  items.forEach(function (item) {
    var link = item.querySelector('a');
    if (link && link.getAttribute('href') === id) {
      item.classList.add('active');
    }
  });
}

items.forEach(function (item) {
  item.addEventListener('click', function () {
    var link = item.querySelector('a');
    setActive(link ? link.getAttribute('href') : null);
  });
});

var observer = new IntersectionObserver(function (entries) {
  entries.forEach(function (entry) {
    if (entry.isIntersecting) {
      setActive('#' + entry.target.id);
    }
  });
}, { rootMargin: '-40% 0px -40% 0px', threshold: 0 });

document.querySelectorAll('.MJ__setFollowFrame').forEach(function (frame) {
  observer.observe(frame);
});
